import React, { useContext } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { Checkbox, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { StyledGroup } from '../../../../Co2Climate/AnswerCO2Climate/Steps/GrassSilageStep/style'
import { StyledDivider } from '../ElevenStep/style'
import { SummaryOptionsContext } from '.'

const TierwohlStep: React.FC = () => {
  const { control, setValue, clearErrors } = useFormContext()
  const {
    dryOffStrategyOptions,
    mastitisAntibioticsUseOptions,
    hoofCareFrequencyOptions
  } = useContext(SummaryOptionsContext)

  const watchDryOffStrategy = useWatch({ control, name: 'additionalQuestions.dryOffStrategy' })
  const watchMastitisAntibiotics = useWatch({ control, name: 'additionalQuestions.mastitisAntibioticsUse' })
  const watchHoofCareFrequency = useWatch({ control, name: 'additionalQuestions.hoofCareFrequency' })
  const watchUseOfPolledGenetics = useWatch({ control, name: 'additionalQuestions.useOfPolledGenetics' })
  const watchAdditionalCowFeatures = useWatch({ control, name: 'additionalQuestions.additionalCowComfortFeatures' })
  const watchTermoDevices = useWatch({ control, name: 'additionalQuestions.thermoregulationDevices' })

  return (
    <div style={{ marginTop: '2em' }}>
      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.additionalCowComfortFeatures'
          rules={{
            required: true
          }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Zusätzl. Einrichtungen des Kuhkomforts: Möglichkeiten zur Fellpflege (z. B. rotierende Kuhbürsten)'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', gap: 20 }}>
                <Checkbox
                  radio
                  label={'Ja'}
                  checked={watchAdditionalCowFeatures === 1}
                  onClick={() => {
                    setValue('additionalQuestions.additionalCowComfortFeatures', 1)
                    clearErrors('additionalQuestions.additionalCowComfortFeatures')
                  }}
                />
                <Checkbox
                  radio
                  label={'Nein'}
                  checked={watchAdditionalCowFeatures === 0}
                  onClick={() => {
                    setValue('additionalQuestions.additionalCowComfortFeatures', 0)
                    clearErrors('additionalQuestions.additionalCowComfortFeatures')
                  }}
                />
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.thermoregulationDevices'
          rules={{
            required: true
          }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Einrichtungen zur Thermoregulation (z. B. Ventilatoren)'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', gap: 20 }}>
                <Checkbox
                  radio
                  label={'Ja'}
                  checked={watchTermoDevices === 1}
                  onClick={() => {
                    setValue('additionalQuestions.thermoregulationDevices', 1)
                    clearErrors('additionalQuestions.thermoregulationDevices')
                  }}
                />
                <Checkbox
                  radio
                  label={'Nein'}
                  checked={watchTermoDevices === 0}
                  onClick={() => {
                    setValue('additionalQuestions.thermoregulationDevices', 0)
                    clearErrors('additionalQuestions.thermoregulationDevices')
                  }}
                />
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.dryOffStrategy'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Strategie beim Trockenstellen'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {dryOffStrategyOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchDryOffStrategy === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.dryOffStrategy', option.key)
                      clearErrors('additionalQuestions.dryOffStrategy')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.mastitisAntibioticsUse'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Einsatz von Antibiotika bei Euterentzündungen '}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {mastitisAntibioticsUseOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchMastitisAntibiotics === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.mastitisAntibioticsUse', option.key)
                      clearErrors('additionalQuestions.mastitisAntibioticsUse')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.hoofCareFrequency'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Häufigkeit eines Routineschnitts/prophylaktische Klauenpflege der Herde'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {hoofCareFrequencyOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchHoofCareFrequency === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.hoofCareFrequency', option.key)
                      clearErrors('additionalQuestions.hoofCareFrequency')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.useOfPolledGenetics'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Einsatz hornloser Genetik'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', gap: 20 }}>
                <Checkbox
                  radio
                  label={'Ja'}
                  checked={watchUseOfPolledGenetics === 1}
                  onClick={() => {
                    setValue('additionalQuestions.useOfPolledGenetics', 1)
                    clearErrors('additionalQuestions.useOfPolledGenetics')
                  }}
                />
                <Checkbox
                  radio
                  label={'Nein'}
                  checked={watchUseOfPolledGenetics === 0}
                  onClick={() => {
                    setValue('additionalQuestions.useOfPolledGenetics', 0)
                    clearErrors('additionalQuestions.useOfPolledGenetics')
                  }}
                />
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>
    </div>
  )
}

export default TierwohlStep
